<template>
    <div class="container mt-5 mb-5 text-center" :class="alto()">
        <h1 class="subtitulo mb-0">Contenido en construcción</h1>
        <img src="@/assets/imagenes/construccion.jpg" class="imagen-construccion">
        <h1 class="subtitulo text-muted mt-0"> {{nombreApartado}} </h1>
        <!-- <h1 class="subtitulo2 mt-0">
            Puede visitar el sitio antiguo <a @click="redireccion">haciendo click aquí</a>
        </h1> -->
    </div>
</template>

<script>
export default {
    props:{
        nombreApartado: null,
        enlace: null,
    },
    methods:{
        redireccion(){
           window.open(this.enlace, '_blank')
        },
        alto(){
            if((screen.width == 1024) && (screen.height == 1366)) return 'ipadPro12'
            if((screen.width == 1366) && (screen.height == 1024)) return 'grande' // a pesar de q este es ipadpro12 horizontal
             if(screen.width > 1900)  return 'grande'
            // if(screen.width > 1280)  return 'medio'
            else return 'medio'
        }
    },
    mounted() {
        // setTimeout(() => this.redireccion(), 6000);
    }

}
</script>

<style scoped>
a{
    text-decoration: none;
    color:brown !important;
}
a:hover{ color: #621132 !important; cursor: pointer !important; }
.imagen-construccion { width: 50%; }

@media only screen and (max-device-width : 900px) {
    .subtitulo { font-size: 1.3rem !important; }
    .subtitulo2 { font-size: .9rem !important; }
    .imagen-construccion { width: 100% !important; }
}

</style>
